// src/Root.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeContextProvider } from "./pages/context/ThemeContext";

export default function RootLayout() {
  return (
    <AuthProvider>
      <ThemeContextProvider>
        <Outlet /> {/* renders the child route */}
      </ThemeContextProvider>
    </AuthProvider>
  );
}